// Dados para as Ferramentas de Planeamento do Casal

// =====================
// RADAR DE DECISÕES DIFÍCEIS
// =====================
export const difficultDecisions = {
  title: "Radar de Decisões Difíceis",
  subtitle: "Temas sensíveis que merecem reflexão calma",
  categories: [
    {
      id: "family",
      name: "Família",
      icon: "Users",
      color: "#B5C4B1",
      scenarios: [
        {
          id: 1,
          title: "Pais divorciados na cerimónia",
          situation: "Os vossos pais estão divorciados e a relação entre eles é tensa. Como gerir a entrada, os lugares e as fotografias?",
          considerations: [
            "A cerimónia é sobre vocês, não sobre resolver conflitos familiares",
            "Não têm obrigação de forçar interações entre pessoas que não se dão bem",
            "É possível honrar ambos os lados sem os colocar em situações desconfortáveis"
          ],
          suggestions: [
            "Conversem separadamente com cada um antes do dia",
            "Definam lugares estratégicos que evitem confrontos",
            "Considerem entradas separadas ou momentos dedicados a cada um"
          ],
          phrases: [
            "\"Queremos que estejas presente e confortável. Vamos encontrar uma forma que funcione para todos.\"",
            "\"Sabemos que a situação é delicada. O mais importante para nós é que estejas lá.\"",
            "\"Não te pedimos que interajas com [pessoa], apenas que partilhes este momento connosco.\""
          ]
        },
        {
          id: 2,
          title: "Familiares que esperam ser convidados",
          situation: "Há familiares distantes ou com quem não têm relação próxima que assumem que serão convidados. Como comunicar que não o serão?",
          considerations: [
            "A lista de convidados é uma decisão vossa, não uma obrigação social",
            "Convidar por pressão cria ressentimento e custos desnecessários",
            "É mais honesto ser claro do que criar falsas expectativas"
          ],
          suggestions: [
            "Definam critérios claros para a lista (ex: contacto nos últimos 2 anos)",
            "Comuniquem a decisão de forma direta mas gentil",
            "Não dêem justificações excessivas - isso abre espaço para negociação"
          ],
          phrases: [
            "\"Tivemos de fazer escolhas difíceis com a lista de convidados. Este ano optámos por uma celebração mais íntima.\"",
            "\"Sabemos que isto pode desiludir, mas queremos ser honestos desde já.\"",
            "\"A decisão não reflete o valor da nossa relação, apenas as limitações que temos.\""
          ]
        },
        {
          id: 3,
          title: "Expectativas sobre netos/gravidez",
          situation: "Familiares fazem comentários ou pressão sobre terem filhos logo após o casamento.",
          considerations: [
            "As vossas decisões sobre família são privadas e pessoais",
            "Não devem justificações a ninguém sobre este tema",
            "Estabelecer limites agora evita pressão contínua"
          ],
          suggestions: [
            "Preparem uma resposta padrão que encerre o assunto",
            "Mudem de assunto de forma natural mas firme",
            "Se persistirem, sejam mais diretos sobre o limite"
          ],
          phrases: [
            "\"Quando tivermos novidades para partilhar, serão os primeiros a saber. Por agora, estamos focados no casamento.\"",
            "\"Preferimos não falar sobre isso - é um tema muito pessoal para nós.\"",
            "\"Agradecemos a preocupação, mas este assunto é só nosso.\""
          ]
        }
      ]
    },
    {
      id: "guests",
      name: "Convidados",
      icon: "UserPlus",
      color: "#D4C4B0",
      scenarios: [
        {
          id: 1,
          title: "Convidados que querem trazer acompanhante",
          situation: "Convidados solteiros pedem para trazer alguém que vocês não conhecem.",
          considerations: [
            "Cada convidado extra tem custo e impacto na intimidade",
            "Não são obrigados a conhecer pessoas novas no vosso casamento",
            "É razoável limitar convites a pessoas que conhecem"
          ],
          suggestions: [
            "Definam uma política clara desde o início",
            "Apliquem a mesma regra a todos para evitar conflitos",
            "Sejam firmes mas compreensivos na comunicação"
          ],
          phrases: [
            "\"Adorávamos incluir toda a gente, mas tivemos de limitar a pessoas que conhecemos pessoalmente.\"",
            "\"Esperamos que compreendas - é uma questão de logística, não de preferência.\"",
            "\"Se não te sentires confortável a vir sozinho/a, compreendemos perfeitamente.\""
          ]
        },
        {
          id: 2,
          title: "Crianças no casamento",
          situation: "Decidiram não ter crianças, mas alguns convidados têm filhos pequenos.",
          considerations: [
            "É uma decisão válida e cada vez mais comum",
            "Alguns pais podem não conseguir vir - e está tudo bem",
            "A decisão deve ser comunicada cedo e aplicada a todos"
          ],
          suggestions: [
            "Incluam a informação no convite de forma elegante",
            "Ofereçam alternativas se possível (babysitting, hotel próximo)",
            "Não façam exceções - cria ressentimento"
          ],
          phrases: [
            "\"Optámos por uma celebração só para adultos. Sabemos que isto pode dificultar a vossa presença e compreendemos se não for possível.\"",
            "\"Queremos que os pais possam relaxar e aproveitar sem preocupações - por isso decidimos um evento sem crianças.\"",
            "\"A decisão aplica-se a todos os convidados, sem exceções, para ser justo.\""
          ]
        }
      ]
    },
    {
      id: "budget",
      name: "Orçamento",
      icon: "Wallet",
      color: "#E8D5D5",
      scenarios: [
        {
          id: 1,
          title: "Contribuições financeiras com condições",
          situation: "Familiares oferecem ajuda financeira mas querem ter palavra nas decisões.",
          considerations: [
            "Dinheiro com condições não é um presente, é um investimento com retorno esperado",
            "Aceitar pode comprometer a vossa autonomia",
            "É legítimo recusar ou negociar os termos"
          ],
          suggestions: [
            "Clarifiquem as expectativas antes de aceitar",
            "Definam limites claros sobre onde podem ou não opinar",
            "Considerem se vale a pena o compromisso"
          ],
          phrases: [
            "\"Agradecemos muito a oferta. Antes de aceitar, queremos garantir que as decisões finais continuam a ser nossas.\"",
            "\"Preferimos um casamento mais simples e totalmente nosso do que um maior com compromissos.\"",
            "\"Podemos aceitar a ajuda para [área específica] e manter o controlo sobre o resto?\""
          ]
        },
        {
          id: 2,
          title: "Conversas sobre dinheiro entre o casal",
          situation: "Têm visões diferentes sobre quanto gastar ou em quê investir.",
          considerations: [
            "Diferenças financeiras são normais e não significam incompatibilidade",
            "O casamento é a primeira grande decisão financeira conjunta",
            "Como resolvem isto define padrões para o futuro"
          ],
          suggestions: [
            "Falem sobre valores, não apenas números",
            "Encontrem o 'porquê' por trás de cada prioridade",
            "Procurem compromissos criativos"
          ],
          phrases: [
            "\"Ajuda-me a perceber porque é que isto é tão importante para ti.\"",
            "\"O que é que podemos cortar que não nos vai fazer falta?\"",
            "\"Vamos definir um limite máximo que ambos aceitamos e trabalhar a partir daí.\""
          ]
        }
      ]
    },
    {
      id: "traditions",
      name: "Tradições",
      icon: "Sparkles",
      color: "#C5D1DC",
      scenarios: [
        {
          id: 1,
          title: "Tradições religiosas quando não são praticantes",
          situation: "Familiares esperam uma cerimónia religiosa, mas vocês não são praticantes.",
          considerations: [
            "A cerimónia deve refletir quem vocês são, não quem os outros querem que sejam",
            "Fingir crenças que não têm é desrespeitoso para todos",
            "Existem formas de honrar a família sem comprometer a autenticidade"
          ],
          suggestions: [
            "Explorem cerimónias civis com elementos simbólicos",
            "Incluam momentos que honrem tradições familiares sem religião",
            "Comuniquem a decisão com respeito mas firmeza"
          ],
          phrases: [
            "\"Respeitamos profundamente a vossa fé, mas não seria honesto da nossa parte fazer uma cerimónia religiosa.\"",
            "\"Queremos criar uma cerimónia que seja verdadeira para nós. Esperamos que compreendam.\"",
            "\"Vamos incluir [elemento específico] que sabemos que é importante para vocês.\""
          ]
        },
        {
          id: 2,
          title: "Recusar tradições que não fazem sentido",
          situation: "Há tradições específicas (buquê, liga, etc.) que não querem incluir.",
          considerations: [
            "Não são obrigados a fazer nada só porque 'sempre se fez assim'",
            "O vosso casamento pode criar novas tradições",
            "A maioria dos convidados não vai notar a ausência"
          ],
          suggestions: [
            "Não precisam de anunciar o que não vão fazer",
            "Se questionados, sejam breves e positivos",
            "Foquem-se no que vão fazer, não no que evitam"
          ],
          phrases: [
            "\"Decidimos focar-nos nas partes que têm mais significado para nós.\"",
            "\"Não é o nosso estilo, mas vai haver muita coisa boa!\"",
            "\"Preferimos criar as nossas próprias tradições.\""
          ]
        }
      ]
    }
  ]
};

// =====================
// PLANEAMENTO POR ENERGIA
// =====================
export const energyPlanning = {
  title: "Planeamento por Energia",
  subtitle: "Tarefas adaptadas ao vosso estado emocional",
  energyLevels: [
    {
      id: "high",
      name: "Energia Alta",
      emoji: "⚡",
      color: "#B5C4B1",
      description: "Sentem-se motivados, focados e prontos para decisões importantes",
      tasks: [
        { task: "Visitar e escolher o local da cerimónia", duration: "3-4h", importance: "alta" },
        { task: "Reunião com potenciais fornecedores", duration: "1-2h", importance: "alta" },
        { task: "Definir orçamento detalhado por categoria", duration: "2h", importance: "alta" },
        { task: "Escolher e encomendar convites", duration: "2h", importance: "média" },
        { task: "Provar vestidos/fatos", duration: "3h", importance: "alta" },
        { task: "Finalizar lista de convidados", duration: "2h", importance: "alta" }
      ],
      message: "Este é o momento ideal para decisões que exigem clareza mental. Aproveitem!"
    },
    {
      id: "medium",
      name: "Energia Moderada",
      emoji: "🌤️",
      color: "#D4C4B0",
      description: "Estão bem, mas preferem tarefas que não exijam muito esforço mental",
      tasks: [
        { task: "Pesquisar inspiração no Pinterest", duration: "30min", importance: "baixa" },
        { task: "Responder a emails de fornecedores", duration: "30min", importance: "média" },
        { task: "Atualizar spreadsheet de convidados", duration: "1h", importance: "média" },
        { task: "Escolher músicas para a playlist", duration: "1h", importance: "baixa" },
        { task: "Rever contratos já recebidos", duration: "1h", importance: "média" },
        { task: "Organizar pasta de inspirações", duration: "30min", importance: "baixa" }
      ],
      message: "Tarefas de manutenção e organização são perfeitas para este momento."
    },
    {
      id: "low",
      name: "Energia Baixa",
      emoji: "🌙",
      color: "#E8D5D5",
      description: "Sentem-se cansados, ansiosos ou sobrecarregados",
      tasks: [
        { task: "Guardar imagens inspiradoras no telemóvel", duration: "15min", importance: "baixa" },
        { task: "Ler um artigo sobre casamentos", duration: "10min", importance: "baixa" },
        { task: "Fazer uma lista do que vos deixa felizes sobre o casamento", duration: "10min", importance: "média" },
        { task: "Enviar uma mensagem de agradecimento a alguém que vos ajudou", duration: "5min", importance: "baixa" },
        { task: "Simplesmente não fazer nada relacionado com o casamento", duration: "∞", importance: "alta" }
      ],
      message: "Está tudo bem em descansar. O casamento não vai a lado nenhum. Cuidem de vocês primeiro."
    },
    {
      id: "overwhelmed",
      name: "Sobrecarregados",
      emoji: "🌊",
      color: "#C5D1DC",
      description: "Sentem-se perdidos, ansiosos ou a questionar tudo",
      tasks: [
        { task: "Respirar fundo e lembrar porque estão a fazer isto", duration: "5min", importance: "alta" },
        { task: "Falar com o/a parceiro/a sobre como se sentem", duration: "20min", importance: "alta" },
        { task: "Escrever 3 coisas que já decidiram e estão bem", duration: "5min", importance: "média" },
        { task: "Delegar uma tarefa a alguém de confiança", duration: "10min", importance: "alta" },
        { task: "Marcar um momento só para o casal, sem falar de casamento", duration: "2h", importance: "alta" }
      ],
      message: "Sentir-se sobrecarregado não significa que estão a falhar. Significa que precisam de pausar. E isso é sabedoria, não fraqueza."
    }
  ]
};

// =====================
// BIBLIOTECA DE DECISÕES REAIS
// =====================
export const realDecisions = {
  title: "Biblioteca de Decisões Reais",
  subtitle: "Histórias honestas de casais reais",
  categories: [
    {
      id: "worth-it",
      name: "Decisões que valeram a pena",
      icon: "Heart",
      stories: [
        {
          id: 1,
          title: "Cortámos a lista de 150 para 60 pessoas",
          couple: "Mariana & Tiago",
          story: "A família esperava um casamento grande. Nós queríamos intimidade. Foi difícil dizer não a tios e primos distantes, mas no dia, conhecíamos e amávamos cada pessoa presente. Não houve um momento em que nos sentíssemos anfitriões de estranhos.",
          lesson: "A pressão social passa. A memória do dia fica.",
          impact: "alta"
        },
        {
          id: 2,
          title: "Investimos 40% do orçamento em fotografia e vídeo",
          couple: "Ana & Pedro",
          story: "Muitos acharam exagerado. Mas dois anos depois, as flores murcharam, a comida foi digerida, e o que resta são as imagens. Cada vez que vemos o vídeo, voltamos àquele dia. Foi o melhor investimento.",
          lesson: "Invistam no que dura, não no que impressiona no momento.",
          impact: "alta"
        },
        {
          id: 3,
          title: "Fizemos a cerimónia civil num jardim pequeno",
          couple: "Sofia & Miguel",
          story: "A família queria igreja. Nós queríamos natureza e simplicidade. Criámos uma cerimónia personalizada com votos próprios. A minha avó, inicialmente contra, disse que foi a cerimónia mais bonita que já viu.",
          lesson: "Autenticidade emociona mais do que tradição automática.",
          impact: "média"
        }
      ]
    },
    {
      id: "regrets",
      name: "Arrependimentos honestos",
      icon: "AlertCircle",
      stories: [
        {
          id: 1,
          title: "Deixámos os pais escolher o catering",
          couple: "Catarina & João",
          story: "Para evitar conflito, deixámos os pais dele escolher o catering. A comida era tradicional e pesada - nada a ver connosco. Cada vez que vemos as fotos do jantar, lembramo-nos que cedemos onde não devíamos.",
          lesson: "Evitar conflito no momento pode criar ressentimento permanente.",
          impact: "média"
        },
        {
          id: 2,
          title: "Não tirámos tempo só para nós durante o dia",
          couple: "Rita & André",
          story: "Estávamos tão focados em cumprimentar todos os convidados que mal nos vimos um ao outro. Devíamos ter planeado 30 minutos só nós dois, longe de todos. Esse momento fez-nos falta.",
          lesson: "Planeiem pausas intencionais só para o casal.",
          impact: "alta"
        },
        {
          id: 3,
          title: "Gastámos demasiado em decoração que ninguém notou",
          couple: "Inês & Ricardo",
          story: "Centros de mesa elaborados, detalhes nos guardanapos, mil velas. No dia, com a emoção e a conversa, ninguém reparou. O dinheiro teria sido melhor gasto na lua de mel.",
          lesson: "Os convidados lembram-se de como se sentiram, não do que viram.",
          impact: "média"
        }
      ]
    },
    {
      id: "compromises",
      name: "Compromissos inevitáveis",
      icon: "Scale",
      stories: [
        {
          id: 1,
          title: "Incluímos 20 pessoas que não queríamos",
          couple: "Beatriz & Gonçalo",
          story: "Havia familiares que não podíamos excluir sem causar uma ruptura permanente. Incluímo-los. Não foi ideal, mas preservou relações importantes. Às vezes, o compromisso é a decisão mais madura.",
          lesson: "Nem tudo é preto ou branco. Escolham as vossas batalhas.",
          impact: "média"
        },
        {
          id: 2,
          title: "Casamento em dois dias: civil íntimo, festa grande",
          couple: "Leonor & Francisco",
          story: "Não conseguíamos conciliar o nosso desejo de intimidade com a expectativa familiar de celebração. Solução: cerimónia civil só com 15 pessoas, festa no dia seguinte com 120. Tivemos os dois mundos.",
          lesson: "Soluções criativas podem satisfazer necessidades opostas.",
          impact: "alta"
        }
      ]
    }
  ]
};

// =====================
// MODO DE TRADIÇÕES
// =====================
export const traditionsMode = {
  title: "Modo de Tradições",
  subtitle: "Escolham como querem lidar com cada tradição",
  traditions: [
    {
      id: "ceremony",
      category: "Cerimónia",
      items: [
        {
          id: 1,
          name: "Entrada da noiva com o pai",
          description: "Tradição onde o pai acompanha a noiva até ao altar",
          options: {
            follow: "Entrada clássica com o pai",
            adapt: "Entrada com ambos os pais, ou outra pessoa significativa",
            ignore: "Noiva entra sozinha ou com o noivo"
          }
        },
        {
          id: 2,
          name: "Votos tradicionais",
          description: "Votos pré-definidos pela cerimónia civil ou religiosa",
          options: {
            follow: "Usar os votos tradicionais completos",
            adapt: "Combinar votos tradicionais com palavras pessoais",
            ignore: "Escrever votos completamente personalizados"
          }
        },
        {
          id: 3,
          name: "Troca de alianças",
          description: "Momento tradicional de troca de alianças",
          options: {
            follow: "Troca clássica de alianças",
            adapt: "Alianças alternativas (tatuagem, outro objeto simbólico)",
            ignore: "Sem alianças ou com outro ritual"
          }
        }
      ]
    },
    {
      id: "reception",
      category: "Receção",
      items: [
        {
          id: 4,
          name: "Bouquet da noiva",
          description: "Tradição de atirar o bouquet às solteiras",
          options: {
            follow: "Lançamento tradicional do bouquet",
            adapt: "Oferecer o bouquet a alguém especial",
            ignore: "Guardar ou não incluir este momento"
          }
        },
        {
          id: 5,
          name: "Primeira dança",
          description: "Dança do casal que abre o baile",
          options: {
            follow: "Primeira dança clássica, só o casal",
            adapt: "Dança curta seguida de convite aos convidados",
            ignore: "Abrir a pista diretamente com todos"
          }
        },
        {
          id: 6,
          name: "Corte do bolo",
          description: "Momento tradicional de cortar o bolo juntos",
          options: {
            follow: "Corte tradicional com fotos",
            adapt: "Corte discreto sem cerimónia",
            ignore: "Sem bolo ou bolo já cortado"
          }
        },
        {
          id: 7,
          name: "Discursos",
          description: "Discursos de padrinhos, pais ou amigos",
          options: {
            follow: "Discursos formais durante o jantar",
            adapt: "Momento informal para quem quiser falar",
            ignore: "Sem discursos formais"
          }
        }
      ]
    },
    {
      id: "attire",
      category: "Vestuário",
      items: [
        {
          id: 8,
          name: "Vestido branco",
          description: "Noiva vestida de branco",
          options: {
            follow: "Vestido branco tradicional",
            adapt: "Branco com detalhes coloridos ou champanhe",
            ignore: "Cor completamente diferente"
          }
        },
        {
          id: 9,
          name: "Véu",
          description: "Véu tradicional da noiva",
          options: {
            follow: "Véu tradicional longo",
            adapt: "Véu curto ou decorativo",
            ignore: "Sem véu"
          }
        }
      ]
    }
  ]
};

// =====================
// LINHA DO TEMPO EMOCIONAL
// =====================
export const emotionalTimeline = {
  title: "Linha do Tempo Emocional",
  subtitle: "Fases normais do planeamento - não estão sozinhos",
  phases: [
    {
      id: 1,
      name: "Lua de Mel do Noivado",
      period: "0-2 meses",
      emoji: "🌟",
      color: "#B5C4B1",
      description: "Tudo parece mágico e possível. Estão cheios de ideias e energia.",
      feelings: ["Entusiasmo", "Felicidade", "Impaciência positiva", "Sonhar acordados"],
      challenges: ["Podem fazer promessas irrealistas", "Dificuldade em focar nas prioridades"],
      advice: "Aproveitem esta energia, mas não tomem decisões financeiras grandes ainda. Este é o momento de sonhar, não de assinar contratos.",
      normalizer: "É normal sentirem que querem fazer tudo ao mesmo tempo. Respirem."
    },
    {
      id: 2,
      name: "Realidade Inicial",
      period: "2-4 meses",
      emoji: "📋",
      color: "#D4C4B0",
      description: "Os números começam a aparecer. Orçamentos, listas, decisões reais.",
      feelings: ["Surpresa com custos", "Início de stress", "Necessidade de organização", "Primeiras dúvidas"],
      challenges: ["Choque com a realidade financeira", "Conflitos sobre prioridades", "Pressão de opiniões externas"],
      advice: "Este é o momento de definir o orçamento real e as prioridades não-negociáveis. Façam-no juntos, com calma.",
      normalizer: "Se estão a sentir que 'isto é mais difícil do que pensavam', estão a fazer bem. Significa que estão a ser realistas."
    },
    {
      id: 3,
      name: "Maratona de Decisões",
      period: "4-8 meses",
      emoji: "🎯",
      color: "#E8D5D5",
      description: "Fornecedores, escolhas, mais escolhas, ainda mais escolhas.",
      feelings: ["Fadiga de decisão", "Dúvida constante", "Comparação com outros", "Momentos de frustração"],
      challenges: ["Decision fatigue", "Medo de escolher errado", "Tentação de desistir de opiniões próprias"],
      advice: "Não precisam de decidir tudo de uma vez. Priorizem as decisões com deadline real. O resto pode esperar.",
      normalizer: "Se estão fartos de escolher entre opções, é completamente normal. O cérebro humano não foi feito para tantas decisões seguidas."
    },
    {
      id: 4,
      name: "Vale da Dúvida",
      period: "6-10 meses",
      emoji: "🌫️",
      color: "#C5D1DC",
      description: "Questionam escolhas, sentem-se sobrecarregados, podem discutir mais.",
      feelings: ["Ansiedade", "Irritabilidade", "Questionar o sentido de tudo", "Saudades da vida 'normal'"],
      challenges: ["Discussões sobre o casamento afetam a relação", "Vontade de cancelar tudo", "Comparação destrutiva"],
      advice: "Este é o momento mais difícil para muitos casais. Não tomem decisões drásticas. Falem sobre como se sentem, não sobre o casamento.",
      normalizer: "Querer que 'isto acabe' não significa que não se amam ou que estão a errar. Significa que estão cansados. E é válido."
    },
    {
      id: 5,
      name: "Aceitação Calma",
      period: "10-12 meses",
      emoji: "🌸",
      color: "#B5C4B1",
      description: "As grandes decisões estão feitas. Começa a haver luz ao fundo.",
      feelings: ["Alívio", "Aceitação", "Novo entusiasmo", "Gratidão"],
      challenges: ["Últimos detalhes podem parecer esmagadores", "Medo do dia não correr bem"],
      advice: "Confiem nas decisões que tomaram. Agora é cuidar dos detalhes e de vocês próprios.",
      normalizer: "Se estão a sentir uma paz estranha depois de meses de stress, não é indiferença. É o vosso sistema nervoso a recuperar."
    },
    {
      id: 6,
      name: "Reta Final",
      period: "Últimas semanas",
      emoji: "✨",
      color: "#D4C4B0",
      description: "Mistura de ansiedade e antecipação. O dia aproxima-se.",
      feelings: ["Nervosismo", "Emoção", "Impaciência", "Vulnerabilidade"],
      challenges: ["Insónias", "Mudanças de última hora", "Medo do desconhecido"],
      advice: "O que está feito, está feito. Foquem-se em descansar, comer bem, e lembrar porque estão a fazer isto: por amor.",
      normalizer: "Chorar sem razão aparente, rir-se de nervos, querer que passe rápido e ao mesmo tempo que nunca chegue - tudo isto é normal."
    }
  ]
};

// =====================
// MAPA DE CONCESSÕES
// =====================
export const concessionsMap = {
  title: "Mapa de Concessões",
  subtitle: "Identifiquem prioridades e encontrem consenso",
  categories: [
    {
      id: "venue",
      name: "Local & Ambiente",
      icon: "MapPin",
      aspects: [
        { id: 1, name: "Tipo de local (quinta, hotel, praia, cidade)", importance: 0 },
        { id: 2, name: "Distância para os convidados", importance: 0 },
        { id: 3, name: "Interior vs exterior", importance: 0 },
        { id: 4, name: "Capacidade / número de convidados", importance: 0 }
      ]
    },
    {
      id: "style",
      name: "Estilo & Estética",
      icon: "Palette",
      aspects: [
        { id: 5, name: "Nível de formalidade", importance: 0 },
        { id: 6, name: "Paleta de cores", importance: 0 },
        { id: 7, name: "Decoração elaborada vs minimalista", importance: 0 },
        { id: 8, name: "Estilo do vestuário", importance: 0 }
      ]
    },
    {
      id: "experience",
      name: "Experiência",
      icon: "Music",
      aspects: [
        { id: 9, name: "Tipo de comida (sentados, buffet, food trucks)", importance: 0 },
        { id: 10, name: "Open bar vs consumo limitado", importance: 0 },
        { id: 11, name: "Tipo de música (DJ, banda, playlist)", importance: 0 },
        { id: 12, name: "Entretenimento extra", importance: 0 }
      ]
    },
    {
      id: "priorities",
      name: "Prioridades Gerais",
      icon: "Target",
      aspects: [
        { id: 13, name: "Fotografia e vídeo de alta qualidade", importance: 0 },
        { id: 14, name: "Conforto dos convidados", importance: 0 },
        { id: 15, name: "Originalidade e personalização", importance: 0 },
        { id: 16, name: "Manter-se dentro do orçamento", importance: 0 }
      ]
    }
  ],
  importanceLevels: [
    { value: 1, label: "Posso ceder", color: "#B5C4B1" },
    { value: 2, label: "Prefiro, mas negociável", color: "#D4C4B0" },
    { value: 3, label: "Importante para mim", color: "#E8D5D5" },
    { value: 4, label: "Não negociável", color: "#C5D1DC" }
  ]
};

// =====================
// CLÁUSULA DO DIA SEGUINTE
// =====================
export const nextDayClause = {
  title: "Cláusula do Dia Seguinte",
  subtitle: "Antes de decidir, perguntem: isto ainda vai importar amanhã?",
  questions: [
    {
      id: 1,
      question: "Daqui a um ano, vamos lembrar-nos desta decisão?",
      context: "Se a resposta for não, provavelmente não merece tanto stress."
    },
    {
      id: 2,
      question: "Estamos a decidir isto por nós ou pelos outros?",
      context: "Se é para impressionar ou agradar terceiros, reconsiderem."
    },
    {
      id: 3,
      question: "Se ninguém soubesse, faríamos na mesma?",
      context: "As melhores decisões passam neste teste."
    },
    {
      id: 4,
      question: "Isto aproxima-nos ou afasta-nos enquanto casal?",
      context: "O casamento é sobre vocês dois. Tudo o resto é secundário."
    },
    {
      id: 5,
      question: "Estamos a reagir ao stress ou a decidir com clareza?",
      context: "Se estão cansados ou ansiosos, adiem a decisão 24h."
    }
  ],
  examples: [
    {
      situation: "Gastar mais €500 em centros de mesa elaborados",
      analysis: "Os convidados vão lembrar-se? Provavelmente não. Este dinheiro faria diferença na lua de mel? Provavelmente sim.",
      verdict: "Pode esperar / Reconsiderar"
    },
    {
      situation: "Incluir um tio distante que a mãe insiste",
      analysis: "Vai criar tensão familiar durante anos se não convidarem? Se sim, pode valer o compromisso. Se não, mantenham a vossa decisão.",
      verdict: "Avaliar impacto a longo prazo"
    },
    {
      situation: "Mudar a data porque um amigo não pode nessa",
      analysis: "Um amigo, por mais querido que seja, não deve ditar a data do vosso casamento. Haverá outras formas de o incluir.",
      verdict: "Manter a decisão original"
    }
  ]
};
